var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgShareMobile = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 33,
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.588,
    y: 0.423,
    width: 32.185,
    height: 32.185,
    rx: 16.093,
    fill: "#1A1C1F"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.705 17.857a2.682 2.682 0 0 0-2.065.992l-3.42-1.575a2.44 2.44 0 0 0 0-1.516l3.42-1.575a2.682 2.682 0 1 0-.57-1.214l-3.54 1.63a2.681 2.681 0 1 0 0 3.835l3.54 1.629c-.029.157-.045.316-.047.476a2.681 2.681 0 1 0 2.682-2.682zm0-6.705a1.34 1.34 0 1 1 0 2.682 1.34 1.34 0 0 1 0-2.682zm-8.046 6.705a1.342 1.342 0 1 1 0-2.684 1.342 1.342 0 0 1 0 2.684zm8.046 4.023a1.341 1.341 0 1 1 0-2.683 1.341 1.341 0 0 1 0 2.683z",
    fill: "#fff"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgShareMobile, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/share_mobile.27dcb68a.svg";
export { ForwardRef as ReactComponent };